/*
 * @Description: 业务申办
 */
import request from "_private/utils/request";
//--------------------申请权限分配----------------------
// 获取一申请企业数据
export function queryCorpList() {
  return request({
    url: "/reserve/apply/list",
    method: "get",
    headers: { type: "json" }
  });
}
// 获取企业下拉框
export function getApplyCompanyList() {
  return request({
    url: "/reserve/apply/company",
    method: "get",
    headers: { type: "json" }
  });
}

// 删除可申请企业数据
export function deleteCorp(data) {
  return request({
    url: "/reserve/apply/delete",
    method: "post",
    data,
    headers: { type: "json" }
  });
}
// 保存申请企业数据
export function saveCorp(data) {
  return request({
    url: "/reserve/apply/save",
    method: "post",
    headers: { type: "json" },
    data
  });
}
// 保存申请企业数据
export function getApplyPurview(data) {
  return request({
    url: "/reserve/apply/purview",
    method: "get",
    headers: { type: "json" },
    data
  });
}
// 保存申请企业数据
export function checkApplyPurview(data) {
  return request({
    url: "/reserve/booking/check",
    method: "post",
    headers: { type: "json" },
    data
  });
}
//------------------------货车通行证预约登记-------------------------
// 仓库下拉列表
export function findStorageAll() {
  return request({
    url: "/base/storage/findStorageAll",
    method: "get"
  });
}
// 车辆下拉列表
export function findVehicleAll() {
  return request({
    url: "/reserve/booking/all",
    method: "get"
  });
}
// 保存预约登记数据
export function saveData(data) {
  return request({
    url: "/reserve/booking/save",
    method: "post",
    headers: { type: "json" },
    data
  });
}
// 修改预约登记数据
export function updateBookingData(data) {
  return request({
    url: "/reserve/booking/update",
    method: "post",
    headers: { type: "json" },
    data
  });
}
// pdf地址解析
export function getPdfUrl(params) {
  return request({
    url: `/app/file/upload/file?fileName=${params}`,
    method: "get"
  });
}
// 查看详情
export function getBookingDetailById(params) {
  return request({
    url: `/reserve/booking/info`,
    method: "get",
    params
  });
}
// 审核数据
export function saveBookingAudit(data) {
  return request({
    url: `/reserve/booking/audit`,
    method: "post",
    headers: { type: "json" },
    data
  });
}

// 删除数据
export function deleteBooking(data) {
  return request({
    url: `/reserve/booking/delete`,
    method: "post",
    headers: { type: "json" },
    data
  });
}
//
export function getCompanyInfo(params) {
  return request({
    url: `/base/compary/getCompanyInfo`,
    method: "get",
    params
  });
}

//------------------------自定义考核内容-------------------------
export function saveSelfFormData(data) {
  return request({
    url: `/appraisal/self/save`,
    method: "post",
    headers: { type: "json" },
    data
  });
}
// 查询详情
export function getAppraisalInfo(params) {
  return request({
    url: `/appraisal/self/info`,
    method: "get",
    headers: { type: "json" },
    params
  });
}

// 删除自评表
export function deleteAppraisalForm(data) {
  return request({
    url: `/appraisal/self/delete`,
    method: "post",
    headers: { type: "json" },
    data
  });
}
// 停止和启用
export function setAppraisalFormStatus(data) {
  return request({
    url: `/appraisal/self/status`,
    method: "post",
    headers: { type: "json" },
    data
  });
}
// 根据年份查询企业自评表
export function getFormNameList(params) {
  return request({
    url: `/appraisal/self/name/list`,
    method: "get",
    headers: { type: "json" },
    params
  });
}

// 查询企业提交详情
export function getCorpSubmitDetail(params) {
  return request({
    url: `/appraisal/self/company`,
    method: "get",
    headers: { type: "json" },
    params
  });
}

//---------------------企业自评表--------------------------
// 根据年份查询企业自评表
export function getCompanyFormNameList(params) {
  return request({
    url: `/appraisal/company/name/list`,
    method: "get",
    headers: { type: "json" },
    params
  });
}
// 查询详情
export function getAppraisalCompanyInfo(params) {
  return request({
    url: `/appraisal/company/info`,
    method: "get",
    headers: { type: "json" },
    params
  });
}
// 保存填写表单
export function saveCompanyForm(data) {
  return request({
    url: `/appraisal/company/save`,
    method: "post",
    headers: { type: "json" },
    data
  });
}
// 保存审核表单
export function saveAuditCompanyForm(data) {
  return request({
    url: `/appraisal/company/audit`,
    method: "post",
    headers: { type: "json" },
    data
  });
}
